import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, FormGroup} from 'react-bootstrap';
import {signUpPressed} from '../actions';
import {loading, onError} from "../actions/index";
import EmailInput from './common/EmailInput';
import PasswordInput from './common/PasswordInput';


class SignUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            name: '',
            phone: '',
            passwordVerify: '',
            passwordMismatch: false,
            pwValidation: null
        };
    }

    handleInput = (key, value) => {
        const s = {}
        s[key] = value
        this.setState(s);
    }

    handleSignUp = (dispatch) => {
        if (this.state.password === this.state.passwordVerify) {
            dispatch(signUpPressed({
                email: this.state.email,
                password: this.state.password,
                name: this.state.name,
                phone: this.state.phone
            }));
            this.setState({pwValidation: "success", passwordMismatch: false})
        } else {
            dispatch(loading(false));
            dispatch(onError());
            this.setState({passwordMismatch: true, pwValidation: "error"});
        }
    }

    backButtonClicked = () => {
        this.props.dispatch(onError());
        this.props.backButtonClicked();
    }

    render() {
        return (
            <div className="App">
                <a className="login-back-button" onClick={this.backButtonClicked}>Back</a>
                <EmailInput label="Email Address" placeholder="john@smith.com" onChange={(val) => this.handleInput('email', val)}/>
                <FormGroup validationState={this.state.pwValidation}>
                    <PasswordInput label="Password" placeholder="Password" onChange={(val) => this.handleInput('password', val)}/>
                    <PasswordInput label="Password Again" placeholder="Password Again" onChange={(val) => this.handleInput('passwordVerify', val)}/>
                </FormGroup>
                {this.state.passwordMismatch ? "Passwords do not match" : null}
                <EmailInput label="Name" placeholder="" onChange={(val) => this.handleInput('name', val)}/>
                <EmailInput label="Phone" placeholder="" onChange={(val) => this.handleInput('phone', val)}/>
                <br/>
                <Button onClick={() => this.handleSignUp(this.props.dispatch)}>Sign Up</Button>
            </div>
        );
    }
}

SignUp = connect()(SignUp);

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.jsx